import {omneticApi} from '@dms/api/base';

import {SetTenantContentLanguagesRequest, TenantContentLanguagesResponse} from './types';

export const contentLanguagesApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    getTenantContentLanguages: build.query<TenantContentLanguagesResponse, void>({
      query: () => ({url: '/dms/v1/tenant/content-languages'}),
      providesTags: ['TenantContentLanguages'],
    }),
    setTenantContentLanguages: build.mutation<void, SetTenantContentLanguagesRequest>({
      query: (body) => ({url: '/dms/v1/tenant/content-languages', method: 'PUT', body}),
      invalidatesTags: ['TenantContentLanguages'],
    }),
  }),
});
export const {useGetTenantContentLanguagesQuery, useSetTenantContentLanguagesMutation} =
  contentLanguagesApi;
